import { useMutation } from '@tanstack/react-query'
import { AppBox, AppButton, AppDialog, AppTypography } from 'components/base'
import { ApiQueryKeys } from 'globals/constants'
import { getMDYFormattedDate } from 'globals/functions'
import { FC, useEffect, useState } from 'react'
import { NewsAlertApi, NewsAlertViewModel } from 'sdk'

interface Props {}

export const LatestNewsAlertDialog: FC<Props> = () => {
  const newsAlertApi = new NewsAlertApi()

  const [newsAlert, setNewsAlert] = useState<NewsAlertViewModel | null>(null)
  const { mutate } = useMutation({
    mutationKey: [ApiQueryKeys.newsAlert.getLatestNewsAlert],
    mutationFn: () => newsAlertApi.getLatestNewsAlert(),
    onSuccess: (data) => setNewsAlert(data),
  })

  useEffect(() => {
    const timeout = setTimeout(() => mutate(), 15000)
    return () => clearTimeout(timeout)
  }, [])
  return (
    <AppDialog
      open={!!newsAlert}
      title="Our Latest News"
      maxWidth={'xs'}
      hideFooterCloseBtn={true}
      onClose={() => setNewsAlert(null)}
    >
      <AppBox display={'flex'} flexDirection={'column'} gap={1} justifyContent={'center'}>
        <AppBox textAlign={'center'}>
          <AppTypography>{getMDYFormattedDate(new Date(newsAlert?.ArticleDate ?? ''))}</AppTypography>
          <AppTypography fontWeight={'bold'} fontSize={16}>
            {newsAlert?.Title}
          </AppTypography>
        </AppBox>
        <AppBox justifyContent={'center'}>
          <AppBox
            height={'250px'}
            width={'400px'}
            borderRadius={4}
            style={{
              backgroundImage: `url(${newsAlert?.ImageUrl.replaceAll('\\', '/')})`,
              backgroundSize: 'cover', // Cover the entire area of the box
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
        </AppBox>
        <AppTypography color={'grey.500'} fontSize={14}>
          {newsAlert?.Description}
        </AppTypography>
        <AppTypography
          isColorPrimary={true}
          component={'a'}
          onClick={() => window.open(newsAlert?.ArticleUrl, '_blank')}
        >
          Read More
        </AppTypography>
        <AppBox display={'flex'} justifyContent={'flex-end'} gap={1} paddingTop={4}>
          <AppButton onClick={() => setNewsAlert(null)}>Close</AppButton>
          <AppButton variant="contained" onClick={() => window.open(newsAlert?.ViewAllUrl, '_blank')}>
            View All
          </AppButton>
        </AppBox>
      </AppBox>
    </AppDialog>
  )
}
